export default "__VITE_ASSET__B9F76K6P__"